'use client';

import { useWebHaptics } from 'web-haptics/react';
import { authClient } from '@/lib/auth/client';
import { useTranslations } from '@/i18n/useTranslations';

import NeoTag from '@/ui/components/NeoTag';

import button from '@/styles/button.module.sass';
import text from '@/styles/text.module.sass';
import styles from './Profile.module.sass';

export default function LoginView() {
  const { t, tbr } = useTranslations('LoginPage');
  const { trigger } = useWebHaptics();

  return (
    <>
      <div className={styles.verticalWrapper}>
        <h1 className={text.h1}>{t('login')}</h1>
        <p className={text.p}>
          {tbr('description_1')} <NeoTag />
          <br />
          {t('description_2')}
        </p>
        <button
          className={button.accent}
          onClick={() => {
            void authClient.signIn.oauth2({ providerId: 'telegram', callbackURL: '/profile' });
            trigger('medium');
          }}
        >
          {t('loginWithTelegram')}
        </button>
      </div>
    </>
  );
}
